import { render, staticRenderFns } from "./HeroCards.vue?vue&type=template&id=dc247ef8&scoped=true&"
import script from "./HeroCards.vue?vue&type=script&lang=js&"
export * from "./HeroCards.vue?vue&type=script&lang=js&"
import style0 from "./HeroCards.vue?vue&type=style&index=0&id=dc247ef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc247ef8",
  null
  
)

export default component.exports